"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const styled_tools_1 = require("styled-tools");
const types_1 = require("../types");
const TextLinkWrapper = styled_components_1.default.a.withConfig({
    shouldForwardProp: (p, defaultValidatorFn) => !['color'].includes(p) && defaultValidatorFn(p),
}) `
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('size', types_1.size.default), {
    [types_1.size.default]: ({ theme }) => theme.fontSize,
    [types_1.size.inherit]: 'inherit',
})};
  letter-spacing: ${({ theme }) => theme.letterSpacing};
  font-weight: ${({ theme }) => theme.fontWeight};
  line-height: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('size', types_1.size.default), {
    [types_1.size.default]: ({ theme }) => theme.lineHeight,
    [types_1.size.inherit]: 'inherit',
})};
  text-decoration: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('underline', types_1.underline.never), {
    [types_1.underline.always]: 'underline',
    [types_1.underline.hover]: 'none',
    [types_1.underline.inherit]: 'inherit',
    [types_1.underline.never]: 'none',
})};
  display: ${({ isBlock }) => (isBlock ? 'block' : 'inline-block')};
  margin: ${({ theme }) => theme.textLinkMargin};
  padding: ${({ theme }) => theme.textLinkPadding};
  color: ${props => {
    if (props['aria-disabled']) {
        return props.theme.textLinkColorPrimaryDisabled;
    }
    switch (props.color) {
        case types_1.color.inherit:
            return 'inherit';
        case types_1.color.primary:
        default:
            return props.theme.textLinkColorPrimary;
    }
}};
  box-sizing: border-box;
  background-color: transparent;
  cursor: ${props => (props['aria-disabled'] ? 'default' : 'pointer')};
  transition: color 150ms ease-in;
  outline: none;
  border: none;

  &::-moz-focus-inner {
    border: none;
  }

  &::selection {
    color: ${({ theme }) => theme.textLinkColorPrimarySelected};
    background-color: ${({ theme }) => theme.textLinkBackgroundColorPrimarySelected};
  }

  &:hover {
    outline: none;
    color: ${props => props['aria-disabled']
    ? props.theme.textLinkColorPrimaryDisabled
    : (0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', types_1.color.primary), {
        [types_1.color.primary]: props.theme.textLinkColorPrimaryHover,
        [types_1.color.inherit]: 'inherit',
    })};
    text-decoration: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('underline', types_1.underline.never), {
    [types_1.underline.always]: 'underline',
    [types_1.underline.hover]: 'underline',
    [types_1.underline.never]: 'none',
})};
  }

  &:focus-visible {
    outline: none;
    color: ${props => props['aria-disabled']
    ? props.theme.textLinkColorPrimaryDisabled
    : (0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', types_1.color.primary), {
        [types_1.color.primary]: props.theme.textLinkColorPrimary,
        [types_1.color.inherit]: 'inherit',
    })};
    border-radius: ${({ theme }) => theme.textLinkBorderRadiusFocus};
    text-decoration: none;
    box-shadow: inset
      ${({ theme }) => `0 0 0 ${theme.textLinkBorderWidthFocus}  ${theme.textLinkShadowColorFocus}`};
  }

  &:active {
    color: ${props => props['aria-disabled']
    ? props.theme.textLinkColorPrimaryDisabled
    : (0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', types_1.color.primary), {
        [types_1.color.primary]: props.theme.textLinkColorPrimaryActive,
        [types_1.color.inherit]: 'inherit',
    })};
  }
`;
exports.default = TextLinkWrapper;
